import CartegoryList from './CategoryList'

export default CartegoryList
